var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFriendsIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 78,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 20c0 12-9 24-20 24S21 32 21 20C21 9 30 0 41 0s20 9 20 20Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 65v7c1 6 8 5-4 5-23 0-41 2-41-10 0-13 18-24 41-23 9 0 11 0 18 3 5 4 2 5-3 8s-9 5-11 10ZM87 38c0 8-6 16-13 16-8 0-14-8-14-16s6-14 14-14c7 0 13 6 13 14Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100 70c0 9-12 7-26 7-15 0-27 2-27-7s12-17 27-17c14 0 26 8 26 17ZM29 38h23v7l5 2H23l6-2 1-2v-3l-1-2Z",
    fill: "#757575"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66 50h16l-1 1v2l1 1 3 1H61l5-1 1-1v-2l-1-1Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendsIconLight);
export default __webpack_public_path__ + "static/media/friends_icon_light.df97d9f5b93e335b47e6f1bd38df6de2.svg";
export { ForwardRef as ReactComponent };